<template>
  <section>
    <base-model :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-model>
    <base-model :show="isLoading" title="Authenticating..." fixed>
      <base-spinner></base-spinner>
    </base-model>
    <div class="formBox">
      <div class="header"><h3>Login</h3></div>
      <form @submit.prevent="submitForm">
        <div class="form-control">
          <div class="box50">
            <span
              :class="{ active: activeClass }"
              class="userType"
              @click="changeType('admin')"
              >Admin</span
            >
          </div>
          <div class="box50">
            <span
              :class="{ active: !activeClass }"
              class="userType"
              @click="changeType('employee')"
              >Employee</span
            >
          </div>
        </div>
        <hr />
        <br />
        <div class="form-control">
          <label for="email">E-Mail</label>
          <input type="email" id="email" v-model.trim="email" />
        </div>
        <div class="form-control">
          <label for="password">Password</label>
          <input type="password" id="password" v-model.trim="password" />
        </div>
        <p v-if="!formIsValid">
          Please enter a valid email and password (must be at least 6 characters
          long).
        </p>
        <div class="box50">
          <base-button>{{ submitButtonCaption }}</base-button>
        </div>
      </form>
      <div class="box50" v-if="activeClass">
        <base-button type="button" mode="flat" @click="switchAuthMode">{{
          switchModeButtonCaption
        }}</base-button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      formIsValid: true,
      mode: "login",
      isLoading: false,
      error: null,
      userType: "admin",
    };
  },
  computed: {
    activeClass() {
      if (this.userType === "admin") {
        return true;
      } else {
        return false;
      }
    },
    submitButtonCaption() {
      if (this.mode === "login") {
        return "Login";
      } else {
        return "Signup";
      }
    },
    switchModeButtonCaption() {
      if (this.mode === "login") {
        return "Signup instead";
      } else {
        return "Login instead";
      }
    },
  },
  methods: {
    changeType(type) {
      this.userType = type;
      if (this.mode === "signup") {
        this.mode = "login";
      }
    },

    async submitForm() {
      this.formIsValid = true;
      if (
        this.email === "" ||
        !this.email.includes("@") ||
        this.password.length < 6
      ) {
        this.formIsValid = false;
        return;
      }

      this.isLoading = true;

      const actionPayload = {
        email: this.email,
        password: this.password,
        userType:this.userType
      };

      try {
        if (this.mode === "login") {
          await this.$store.dispatch("auth/login", actionPayload);
        } else {
          await this.$store.dispatch("auth/signup", actionPayload);
        }
        this.$router.replace('/home');
      } catch (err) {
        this.error = err.message || "Failed to authenticate, try later.";
      }

      this.isLoading = false;
    },
    switchAuthMode() {
      if (this.mode === "login") {
        this.mode = "signup";
      } else {
        this.mode = "login";
      }
    },
    handleError() {
      this.error = null;
    },
  },
};
</script>

<style scoped>
.userType {
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  font: inherit;
  background-color: transparent;
  color: #3a0061;
  border: none;
  cursor: pointer;
  border-radius: 30px;
  margin-right: 0.5rem;
  display: inline-block;
}
.userType:hover,
.userType:active {
  background-color: #edd2ff;
}
span.active {
  background-color: #edd2ff;
}
.formBox {
  margin-top: 10%;
  width: 40%;
  margin-left: 30%;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px #313131;
}
form {
  box-sizing: border-box;
  padding: 20px;
}
.header h3 {
  background: #2c3e50;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.box50 {
  display: inline-block;
  width: 50%;
  text-align: center !important;
}
.formOuter {
  padding: 1vw;
  box-sizing: border-box;
}
.formOuter span {
  color: red;
  margin-top: 5px;
}
.form-control {
  width: 100%;
  margin-bottom: 20px;
  text-align: left;
}
.form-control label {
  margin-bottom: 8px;
  width: 100%;
}
.form-control input[type="text"],
.form-control input[type="email"],
.form-control input[type="password"],
.form-control input[type="date"],
.form-control textarea {
  width: 100%;
  border: 1px solid #c1c1c1;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
}

.form-control-group {
  text-align: left;
}
.form-control-group h3 {
  text-align: left;
}
.invalid input,
.invalid textarea {
  border-color: red !important;
}
.invalid span {
  color: red;
  text-align: left;
}
.invalid h3 {
  color: red !important;
}
</style>
